module.exports = __webpack_public_path__ + "617b70749adfc3a3d2d8c44b8fcef4ce.pdf";